import { createContext } from "react";
import type { UseAuthResult } from "../types/types";

export const AuthContext = createContext<UseAuthResult | null>(null);
